module.exports = __webpack_public_path__ + "static/img/pass.80946ad4.svg";